
<p-toast></p-toast>
<p-fieldset
legend="Training Summary"
[toggleable]="true"
[collapsed]="false">
<div class="grid" id="curriculumSummary">
    <div class="col mb-2">
        <app-label labelText="{{ coreCurriculumColumnName }}"></app-label>
        <div *ngFor="let data of trainingPlanDto?.coreCurriculums">
            <div class="mt-1">
            <app-read-only readonlyText="{{data}}"></app-read-only>
            </div>
        </div>
        <div class="mt-2" *ngIf="trainingItemGroupVisible">
          <app-label labelText="{{ trainingItemGroupsLabel }}"></app-label>
          <div *ngFor="let data of trainingPlanDto?.trainingItemGroups">
              <div class="mt-1">
                <app-read-only readonlyText="{{data}}"></app-read-only>
              </div>
          </div>
          <div *ngIf="trainingPlanDto?.trainingItemGroups === null ||
           trainingPlanDto?.trainingItemGroups?.length === 0">
            <app-read-only readonlyText="N/A"></app-read-only>
          </div>
        </div>
    </div>
    <div class="col mb-2">
        <app-label labelText="{{ electiveCurriculumColumnName }}"></app-label>
        <div *ngFor="let data of trainingPlanDto?.electiveCurriculums">
            <div class="mt-1">
                <app-read-only readonlyText="{{data}}"></app-read-only>
            </div>
        </div>
    </div>
</div>
</p-fieldset>
<div class="flex justify-content-center m-3 mt-5 p-5 text-lg">
  <p-button
  appPreventDoubleClick
  icon="fa-regular fa-square-check"
  id="trainingCompletedButton"
  label="{{buttonLabel}}"
  iconPos="left"
  [disabled]="disabled!"
  (debounceClick)="openConfirmationModal()"
></p-button>
</div>
  <p-dialog
      [(visible)]="ifButtonIsClicked"
      [style]="{ width: '30vw' }"
      (onHide)="closeConfirmationModal()"
      [modal]="true"
    >
      <ng-template pTemplate="header">
        <span class="font-semibold text-xl">Confirmation</span>
      </ng-template>
      <div>
        <div class="grid">
          <div class="col">
            <app-label
              labelText="{{ confirmationMessage }}"
            ></app-label>
          </div>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <p-button
        appPreventDoubleClick
          label="No"
          type="submit"
          icon="pi pi-times"
          id="confirmationNoButton"
          styleClass="p-button-outlined"
          class="align-right"
          (debounceClick)="closeConfirmationModal()"
        >
        </p-button>
        <p-button
        appPreventDoubleClick
          label="Yes"
          icon="pi pi-check"
          type="submit"
          id="confirmationYesButton"
          class="align-right"
          (debounceClick)="onConfirm()"
        >
        </p-button>
        
      </ng-template>
    </p-dialog>

    <p-dialog
      [(visible)]="showQuiz"
      [style]="{ width: '60vw' }"
      (onHide)="closeConfirmationModal()"
      [modal]="true"
    >
  <app-quiz-completion *ngIf="showQuiz" [quizDataToDisplay]="quizDataToDisplay" [proficiencyQuizType]="quizType"
  [courseDetail] = "courseDetail" (quizCompletionModalDisplay)="closeQuiz($event)" (completeQuiz) = "reloadTraining()"
  (disableTakeQuizButton) = "disableTakeQuiz($event)"></app-quiz-completion>
</p-dialog>